import React from "react"
import PropTypes from "prop-types"
import styles from "@components/CustomComponents/ArticleContactMethods/index.module.scss"
import { renderRichText } from "@/utils/formatters"
import { useRouter } from "next/router"

const articleContactData = PropTypes.shape({
  title: PropTypes.string,
  Image: PropTypes.array,
});

const ArticleContactMethods =({ articleContactData = {} }) => {
  const { locale } = useRouter()
  const {heading = "", images = [], showBottomLine = true } = articleContactData || {};
  return (
    <section className={styles.wrapper}>
      {heading ? <h2 className="title text-center"><b>{heading}</b></h2> : null}
      <div className="grid grid-cols-3 gap-1 mt-10 mx-2">
        {images.map((item, index) => (
          <div key={index} className="card flex items-center justify-center flex-col gap-1 min-[460px]:gap-2">
            {item?.fields?.imageUrl && (
              <div className="iconBox">
                <img
                  src={item?.fields?.imageUrl}
                  alt={item?.fields?.alt}
                  className="image-icon"
                />
              </div>
            )}
        {item?.fields?.description ?  (
              <div className="text  contact-text text-center font-bold">
              {renderRichText(item?.fields?.description, locale)}
              </div>
            ) : null}
     
          </div>
        ))}
      </div>
       <div className="line">
        {showBottomLine && <div className="cardDivider"></div>}
      </div>
    </section>
  );
};

export default ArticleContactMethods;
